class PortalEmbedFrame {
    notifyParent() {
        parent.postMessage("ClientPortalLoading", "*");
    }
}

new PortalEmbedFrame().notifyParent();
